import type { VisibilityCondition } from '../core/schema/types';
import { evaluateCondition } from './evaluateCondition';

export function isRowSelectable(
  row: Record<string, unknown>,
  selectable: VisibilityCondition | null
): boolean {
  if (!selectable) return true;
  return evaluateCondition(selectable, row);
}
